import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import TopNavigation from './TopNavigation';
import ClueRaiderBanner from './components/ClueRaiderBanner';
import MailerLiteSignup from './components/MailerLiteSignup';
// import book0 from './book0.png'; // Commented out - book banners are hidden
import s0 from './s0.png';
import s1 from './s1.png';
import s2 from './s2.png';
import s3 from './s3.png';
import s4 from './s4.png';
import s5 from './s5.png';
import s6 from './s6.png';
import s7 from './s7.png';
import s8 from './s8.png';
import s9 from './s9.png';
import s10 from './s10.png';

// How to Play images
import howToPlay1 from './how-to-play-1-open-case.png';
import howToPlay2 from './how-to-play-2-stars-affinities.png';
import ss1 from './ss1.png';
import ss2 from './ss2.png';
import ss3 from './ss3.png';
import affinities from './affinities.png';
import tiktokIcon from './TikTok_Icon_Black_Circle.png';
import { updatePageSEO } from './utils/seo';


const GettingStarted: React.FC = () => {
  const [showWalkthrough, setShowWalkthrough] = useState(false);

  useEffect(() => {
    updatePageSEO(
      'How to Play Dimension Flux - Getting Started Guide',
      'Learn how to play Dimension Flux: solve daily inter-dimensional logic puzzles by eliminating suspects, following cryptic clues, and identifying the Being, Weapon, and Hideout responsible for each incident.'
    );
  }, []);

  return (
    <div className="min-h-screen bg-gradient-to-br from-purple-900 via-blue-900 to-indigo-900 text-white">
      {/* Top Navigation */}
      <TopNavigation />
      <ClueRaiderBanner />

             <div className="max-w-xl mx-auto w-full p-2 sm:p-4">

                 {/* NEW HOW TO PLAY CONTENT */}
         <div className="bg-white bg-opacity-95 rounded-lg p-2 sm:p-6 border-2 border-gray-300 shadow-lg mb-3 sm:mb-6 w-full">
                       <div className="text-center mb-3 sm:mb-6">
              <h1 className="text-xl sm:text-3xl font-oswald font-bold text-gray-900 mb-2 sm:mb-4">How to Play</h1>
                             <p className="text-sm sm:text-base font-lora font-bold text-gray-700 text-left">
                               Your mission is to identify the <span className="font-semibold">Being</span>, <span className="font-semibold">Weapon</span> and <span className="font-semibold">Hideout</span> responsible for causing the Flux incident by following the steps below.
                             </p>
            </div>
           
           <div className="space-y-4 sm:space-y-8 text-gray-800 font-lora text-sm sm:text-base leading-relaxed">
            <div className="w-full h-px bg-gray-300 mb-2"></div>
            
                                                   {/* Step 1: Open a Case */}
              <div className="flex flex-col gap-3 sm:gap-6">
                <div className="flex items-center gap-3 mb-1">
                  <div className="w-8 h-8 sm:w-12 sm:h-12 bg-purple-100 rounded-full flex items-center justify-center text-sm sm:text-lg font-bold text-purple-600 flex-shrink-0">1</div>
                                     <h3 className="text-base sm:text-lg font-oswald font-semibold text-gray-900">Open a Case</h3>
                </div>
                <p className="text-gray-700 text-sm sm:text-base mb-2">Each puzzle begins with a new Flux incident.  The Incident has a Flux rating between 1 and 5, a named location and a planetary affinity all of which may be referenced in the clues used to solve the case</p>
                <div className="mb-3 sm:mb-4 p-2 sm:p-4 bg-gray-50 rounded-lg border border-gray-200">
                  <img src={howToPlay1} alt="Newspaper-style headline screenshot" className="w-full rounded" />
                </div>
              </div>

                                                                             {/* Step 2: Suspect Stars & Affinities */}
              <div className="flex flex-col gap-3 sm:gap-6">
                <div className="flex items-center gap-3 mb-1">
                  <div className="w-8 h-8 sm:w-12 sm:h-12 bg-purple-100 rounded-full flex items-center justify-center text-sm sm:text-lg font-bold text-purple-600 flex-shrink-0">2</div>
                                     <h3 className="text-base sm:text-lg font-oswald font-semibold text-gray-900">SUSPECTS</h3>
                </div>
                <p className="text-gray-700 text-sm sm:text-base mb-2">The suspected Beings, Weapons and Hideouts each have a star rating and planetary affinity. The clues will use these attrbutes to help find the solution.</p>
                <div className="mb-3 sm:mb-4 p-2 sm:p-4 bg-gray-50 rounded-lg border border-gray-200">
                  <img src={howToPlay2} alt="Grid of 5 Beings, 5 Weapons, 5 Hideouts" className="w-full rounded" />
                </div>
                <div className="mb-3 sm:mb-4 p-2 sm:p-4 bg-gray-50 rounded-lg border border-gray-200">
                  <img src={affinities} alt="Affinities explanation" className="w-full rounded" />
                </div>
              </div>

                                                                             {/* Step 3: Reveal Clues & Eliminate Suspects */}
              <div className="flex flex-col gap-3 sm:gap-6">
                <div className="flex items-center gap-3 mb-1">
                  <div className="w-8 h-8 sm:w-12 sm:h-12 bg-purple-100 rounded-full flex items-center justify-center text-sm sm:text-lg font-bold text-purple-600 flex-shrink-0">3</div>
                                   <h3 className="text-base sm:text-lg font-oswald font-semibold text-gray-900">Reveal Clues & Eliminate Suspects</h3>
                </div>
                <p className="text-gray-700 text-sm sm:text-base mb-2">Four or more logical clues guide your deductions.  Use logic to rule out the impossible and find the Being, Weapon and Hideout responsible for the breach.</p>
                <div className="mb-3 sm:mb-4 p-2 sm:p-4 bg-gray-50 rounded-lg border border-gray-200">
                  <img src={ss1} alt="Clues and suspect elimination" className="w-full rounded" />
                </div>
              </div>

                                                     {/* Step 4: Propose a Solution */}
              <div className="flex flex-col gap-3 sm:gap-6">
                <div className="flex items-center gap-3 mb-1">
                  <div className="w-8 h-8 sm:w-12 sm:h-12 bg-purple-100 rounded-full flex items-center justify-center text-sm sm:text-lg font-bold text-purple-600 flex-shrink-0">4</div>
                                   <h3 className="text-base sm:text-lg font-oswald font-semibold text-gray-900">Propose a Solution</h3>
                </div>
                <p className="text-gray-700 text-sm sm:text-base mb-2">You have one attempt to propose the correct solution. Choose wisely!</p>
                <div className="mb-3 sm:mb-4 p-2 sm:p-4 bg-gray-50 rounded-lg border border-gray-200">
                  <img src={ss2} alt="Propose solution screen" className="w-full rounded" />
                </div>
              </div>

                                                     {/* Step 5: Solve the Case */}
              <div className="flex flex-col gap-3 sm:gap-6">
                <div className="flex items-center gap-3 mb-1">
                  <div className="w-8 h-8 sm:w-12 sm:h-12 bg-purple-100 rounded-full flex items-center justify-center text-sm sm:text-lg font-bold text-purple-600 flex-shrink-0">5</div>
                                   <h3 className="text-base sm:text-lg font-oswald font-semibold text-gray-900">Solve the Case</h3>
                </div>
                <p className="text-gray-700 text-sm sm:text-base mb-2">Submit the only valid solution to seal the breach.</p>
                <p className="text-sm sm:text-base font-lora text-gray-700 mt-2 text-left italic">
                  Note: puzzle difficulty increases from Easy (Monday) to Expert (Sunday) – try 
                  {' '}
                  <a
                    href="https://dimensionflux.com/?date=20251117"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-purple-700 underline"
                  >
                    this gentle Monday puzzle
                  </a>
                  {' '}
                  after reviewing this page or 
                  {' '}
                  <a
                    href="https://www.tiktok.com/@dimension_flux/video/7561503088922692886"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-purple-700 underline"
                  >
                    see it in action
                  </a>
                  {' '}
                  to learn more.
                </p>
                <div className="mb-3 sm:mb-4 p-2 sm:p-4 bg-gray-50 rounded-lg border border-gray-200">
                  <img src={ss3} alt="Case solved screen" className="w-full rounded" />
                </div>
              </div>

          </div>
        </div>

        

        {/* Sample Case Walkthrough - hidden */}
        {false && (
        <div className="bg-white bg-opacity-95 rounded-lg p-3 sm:p-6 border-2 border-gray-300 shadow-lg mb-4 sm:mb-6 w-full">
          <div className="text-center mb-3 sm:mb-4">
            <h3 className="text-xs sm:text-sm font-oswald font-bold text-gray-600 mb-1">
              TRAINING EXERCISE
            </h3>
            <h4 className="text-xs font-oswald text-gray-500 mb-2">
              STEP-BY-STEP DEMONSTRATION
            </h4>
            <div className="w-12 sm:w-16 h-px bg-gray-400 mx-auto mb-2 sm:mb-3"></div>
          </div>
          
                     <h2 className="text-xl sm:text-2xl font-oswald font-bold text-gray-900 mb-3 sm:mb-4 text-center leading-tight">SAMPLE CASE WALKTHROUGH</h2>
           
           <div className="w-full h-px bg-gray-300 mb-3 sm:mb-4"></div>
           
           {!showWalkthrough && (
             <div className="text-center">
               <p className="text-gray-600 mb-4">See a complete case solved step-by-step...</p>
               <button
                 onClick={() => setShowWalkthrough(true)}
                 className="px-6 py-2 bg-purple-600 hover:bg-purple-700 text-white rounded-lg font-semibold transition-colors duration-200"
               >
                 Read More
               </button>
             </div>
           )}
           
           {showWalkthrough && (
            <div className="space-y-6 text-gray-800 font-lora text-sm sm:text-base">
            <div>
              <h3 className="font-oswald font-semibold text-gray-900 mb-2">Step 1: Case Introduction</h3>
              <p className="mb-3">We start with a mysterious incident that requires investigation. Our goal is to identify three key elements: the Dimension Flux being responsible, the weapon they used to cause the incident, and where they are currently hiding.</p>
              <div className="h-8"></div>
              <div className="flex justify-center px-4">
                <div className="w-full max-w-sm lg:max-w-md">
                  <img src={s0} alt="Case Introduction" className="w-full rounded-lg shadow-lg" />
                </div>
              </div>
              <div className="h-8"></div>
            </div>

            <div>
              <h3 className="font-oswald font-semibold text-gray-900 mb-2">Step 2: Review Initial Clues</h3>
              <p className="mb-3">We've revealed the first two clues and paused to analyze our options. Use logic and deduction to narrow down the suspects.</p>
              <div className="h-8"></div>
              <div className="flex justify-center px-4">
                <div className="w-full max-w-sm lg:max-w-md">
                  <img src={s1} alt="Review Initial Clues" className="w-full rounded-lg shadow-lg" />
                </div>
              </div>
              <div className="h-8"></div>
            </div>

            <div>
              <h3 className="font-oswald font-semibold text-gray-900 mb-2">Step 3: Narrow Down Suspects</h3>
              <p className="mb-3">Since the first two clues don't eliminate any suspects immediately, we continue gathering information by revealing more clues and using logical deduction to narrow down possibilities.</p>
              <div className="h-8"></div>
              <div className="flex justify-center px-4">
                <div className="w-full max-w-sm lg:max-w-md">
                  <img src={s2} alt="Free Proposal" className="w-full rounded-lg shadow-lg" />
                </div>
              </div>
              <div className="h-8"></div>
            </div>

            <div>
              <h3 className="font-oswald font-semibold text-gray-900 mb-2">Step 4: Use Logic to Eliminate</h3>
              <p className="mb-3">By combining clues and using logical deduction, we can eliminate suspects that don't match the criteria. Each clue helps narrow down the possibilities until only one valid solution remains.</p>
              <div className="h-8"></div>
              <div className="flex justify-center px-4">
                <div className="w-full max-w-sm lg:max-w-md">
                  <img src={s3} alt="Proposal Results" className="w-full rounded-lg shadow-lg" />
                </div>
              </div>
              <div className="h-8"></div>
            </div>

            <div>
              <h3 className="font-oswald font-semibold text-gray-900 mb-2">Step 5: Mark Eliminated Suspects</h3>
              <p className="mb-3">Using the feedback from our proposal, we can now cross off suspects that are no longer possible based on the information we've gathered.</p>
              <div className="h-8"></div>
              <div className="flex justify-center px-4">
                <div className="w-full max-w-sm lg:max-w-md">
                  <img src={s4} alt="Mark Eliminated Suspects" className="w-full rounded-lg shadow-lg" />
                </div>
              </div>
              <div className="h-8"></div>
            </div>

            <div>
              <h3 className="font-oswald font-semibold text-gray-900 mb-2">Step 6: Reveal the Next Clue</h3>
              <p className="mb-3">We reveal the third clue to gather more information and continue narrowing down our suspect list.</p>
              <div className="h-8"></div>
              <div className="flex justify-center px-4">
                <div className="w-full max-w-sm lg:max-w-md">
                  <img src={s5} alt="Reveal Next Clue" className="w-full rounded-lg shadow-lg" />
                </div>
              </div>
              <div className="h-8"></div>
            </div>

            <div>
              <h3 className="font-oswald font-semibold text-gray-900 mb-2">Step 7: Continue Elimination</h3>
              <p className="mb-3">We know the being has an odd number of stars (1), and the third clue tells us the hideout must have an even number of stars (2 or 4). This helps us eliminate more suspects.</p>
              <div className="h-8"></div>
              <div className="flex justify-center px-4">
                <div className="w-full max-w-sm lg:max-w-md">
                  <img src={s6} alt="Continue Elimination" className="w-full rounded-lg shadow-lg" />
                </div>
              </div>
              <div className="h-8"></div>
            </div>

            <div>
              <h3 className="font-oswald font-semibold text-gray-900 mb-2">Step 8: Further Elimination</h3>
              <p className="mb-3">Since we know the weapon and hideout star ratings differ by exactly 2, we can eliminate more options. However, we still have 2 valid solutions, so rather than guessing, we'll reveal the final clue to be certain.</p>
              <div className="h-8"></div>
              <div className="flex justify-center px-4">
                <div className="w-full max-w-sm lg:max-w-md">
                  <img src={s7} alt="Further Elimination" className="w-full rounded-lg shadow-lg" />
                </div>
              </div>
              <div className="h-8"></div>
            </div>

            <div>
              <h3 className="font-oswald font-semibold text-gray-900 mb-2">Step 9: Final Clue</h3>
              <p className="mb-3">The final clue reveals that Echo Drone cannot be the weapon because its affinity doesn't match the being or hideout. This eliminates the last possibility, leaving us with only one valid solution. Note - when clues reference "or" it is inclusive so this clue can be read as "being or hideout (or both)"</p>
              <div className="h-8"></div>
              <div className="flex justify-center px-4">
                <div className="w-full max-w-sm lg:max-w-md">
                  <img src={s8} alt="Final Clue" className="w-full rounded-lg shadow-lg" />
                </div>
              </div>
              <div className="h-8"></div>
            </div>

            <div>
              <h3 className="font-oswald font-semibold text-gray-900 mb-2">Step 10: Submit Proposal</h3>
              <p className="mb-3">With only one solution remaining, we submit our final proposal. If our logic is correct, this should be the right answer.</p>
              <div className="h-8"></div>
              <div className="flex justify-center px-4">
                <div className="w-full max-w-sm lg:max-w-md">
                  <img src={s9} alt="Submit Proposal" className="w-full rounded-lg shadow-lg" />
                </div>
              </div>
              <div className="h-8"></div>
            </div>

            <div>
              <h3 className="font-oswald font-semibold text-gray-900 mb-2">Step 11: Case Solved!</h3>
              <p className="mb-3">Success! Our logic was correct and we've successfully solved the case in our one and only attempt!</p>
              <div className="h-8"></div>
              <div className="flex justify-center px-4">
                <div className="w-full max-w-sm lg:max-w-md">
                  <img src={s10} alt="Case Solved" className="w-full rounded-lg shadow-lg" />
                </div>
              </div>
              <div className="h-8"></div>
            </div>
                         
             <div className="text-center mt-6">
               <button
                 onClick={() => setShowWalkthrough(false)}
                 className="px-6 py-2 bg-gray-600 hover:bg-gray-700 text-white rounded-lg font-semibold transition-colors duration-200"
               >
                 Show Less
               </button>
             </div>
           </div>
         )}
        </div>
        )}

        

                          {/* Book banner moved above Newsletter Signup - HIDDEN (can be restored later) */}
                          {/* <div className="w-full md:max-w-xl mx-auto mb-3 mt-2">
                            <Link to="/book" className="block">
                              <div className="flex flex-row items-stretch bg-white/95 border border-slate-200 rounded-2xl shadow-lg hover:shadow-xl transition-shadow duration-200 overflow-hidden">
                                <img src={book0} alt="Dimension Flux Book" className="h-full w-16 sm:w-20 md:w-24 object-cover flex-shrink-0" />
                                <div className="flex-1 flex flex-col justify-center min-w-0 p-2 sm:p-3 md:p-4">
                                  <h3 className="text-xs sm:text-sm md:text-base lg:text-lg font-oswald font-bold text-slate-900 leading-tight mb-1 sm:mb-2.5 whitespace-nowrap overflow-hidden text-ellipsis">
                                    50 NEW DIMENSION FLUX PUZZLES TO TAKE OFFLINE.
                                  </h3>
                                  <span className="text-xs sm:text-xs md:text-sm text-slate-700 font-oswald uppercase tracking-wide leading-tight whitespace-nowrap overflow-hidden text-ellipsis">
                                    LEARN ABOUT THE DIMENSION FLUX BOOK
                                  </span>
                                </div>
                              </div>
                            </Link>
                          </div> */}

                                           {/* Newsletter Signup */}
                          <div className="mt-6 mb-6">
                            <MailerLiteSignup />
                          </div>

                          {/* Always visible closing message */}
                          <div className="text-center mt-6 p-4 bg-gray-100 rounded-lg border border-gray-300">
                            <p className="text-lg font-oswald font-semibold text-gray-700">
                              Solve today's case. Seal the breach. Return tomorrow. The flux never stops.
                            </p>
                          </div>

         {/* Navigation Button */}
         <div className="text-center mt-6 sm:mt-8">
           <Link 
             to="/" 
             className="inline-block px-6 sm:px-8 py-2.5 sm:py-3 bg-gray-800 hover:bg-gray-900 text-white rounded-lg font-semibold text-base sm:text-lg shadow-lg transition-colors duration-200"
           >
             Begin Investigation
           </Link>
         </div>
        {/* See It in Action CTA */}
        <div className="text-center mt-6 mb-4">
          <a 
            href="https://www.tiktok.com/@dimension_flux/video/7561503088922692886" 
            target="_blank" 
            rel="noopener noreferrer"
            className="inline-flex items-center gap-1.5 px-4 py-1.5 bg-gray-800 hover:bg-gray-900 text-white rounded-full text-sm font-oswald font-semibold uppercase tracking-wide transition-colors duration-200"
          >
            <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 24 24">
              <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5 20.1a6.34 6.34 0 0 0 10.86-4.43v-7a8.16 8.16 0 0 0 4.77 1.52v-3.4a4.85 4.85 0 0 1-1-.1z"/>
            </svg>
            See It in Action
          </a>
        </div>

        {/* Social Links */}
        <div className="text-center mt-4 mb-2">
          <a href="https://x.com/Dimension_Flux" target="_blank" rel="noopener noreferrer" className="inline-block mx-2 text-white hover:opacity-80" aria-label="X profile">
            <svg className="w-5 h-5 inline-block align-middle" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
              <path d="M18.244 2H21L13.5 10.5 22.5 22H15.5L10.5 15.5 4.5 22H2L9.5 13.5 1.5 2H8.5L13.5 8.5 18.244 2Z"/>
            </svg>
          </a>
          <a href="https://www.tiktok.com/@dimension_flux" target="_blank" rel="noopener noreferrer" className="inline-block mx-2 hover:opacity-80" aria-label="TikTok profile">
            <img src={tiktokIcon} alt="TikTok" className="w-5 h-5 inline-block align-middle rounded-full" />
          </a>
        </div>

        {/* Copyright + AI Disclosure */}
        <div className="text-center mt-2 text-sm text-white">
          © N.M.A. Pitman 2025 • Contact: <a href="mailto:hello@dimensionflux.com" className="text-white underline">hello@dimensionflux.com</a>
          <div className="mt-1 text-xs opacity-90"><a href="https://www.vecteezy.com/free-vector/portal">Portal Vectors by Vecteezy</a></div>
        </div>
      </div>


    </div>
  );
};

export default GettingStarted; 